import { UnitConstants } from 'src/app/core/constants/unit';
import { ValidatorsTerms } from 'src/app/shared/validators/validators-terms';

const TERMS = ValidatorsTerms;

export class RigidTubeGeneralFields {
  public static controls = {
    externalDiameter: {
      quantity: UnitConstants.QUANTITY.LENGTH,
      validator: TERMS.REQUIRED_SCI_NOTATION_MORE_THAN_ZERO,
    },
    internalDiameter: {
      quantity: UnitConstants.QUANTITY.LENGTH,
      validator: TERMS.REQUIRED_SCI_NOTATION_MORE_THAN_ZERO,
    },
    diameterEffective: {
      quantity: UnitConstants.QUANTITY.LENGTH,
      validator: TERMS.REQUIRED_SCI_NOTATION_MORE_THAN_ZERO,
    },
    morisonDrag: {
      quantity: null,
      validator: TERMS.SCI_NOTATION_AT_LEAST_ZERO,
    },
    morisonDragLongi: {
      quantity: null,
      validator: TERMS.SCI_NOTATION_AT_LEAST_ZERO,
    },
    morisonInertia: {
      quantity: null,
      validator: TERMS.SCI_NOTATION_AT_LEAST_ZERO,
    },
    youngModulus: {
      quantity: UnitConstants.QUANTITY.ELASTIC_MODULE,
      validator: TERMS.REQUIRED_SCI_NOTATION_MORE_THAN_ZERO,
    },
    specificWeight: {
      quantity: UnitConstants.QUANTITY.SPECIFIC_WEIGHT,
      validator: TERMS.SCI_NOTATION_AT_LEAST_ZERO,
    },
    thicknessReduction: {
      quantity: UnitConstants.QUANTITY.LENGTH,
      validator: TERMS.SCI_NOTATION_AT_LEAST_ZERO,
    },
  };
}
